import * as types from '../constants';
import initialState from '../initialState';

export default function reducer(state = initialState.application, action) {
  const { type, payload } = action;
  switch (type) {
    case types.GET_APPLICATION_DETAILS_SUCCESS:
      return {
        ...state,
        details: payload.details,
      };
    case types.GET_APPLICATIONS_SUCCESS:
      return {
        ...state,
        applications: payload.applications,
      };
    case types.GET_APPLICATION_JOB_TITLES_SUCCESS:
      return {
        ...state,
        jobTitles: payload.jobTitles,
      };
    case types.GET_APPLICATION_LANGUAGES_SUCCESS:
      return {
        ...state,
        languages: payload.languages,
      };
    case types.GET_APPLICATION_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: payload.countries,
      };
    default:
      return state;
  }
}
